/**
 * Company context for the public website pages.
 *
 * The host decides. abmedlab.com and the mapped *.xpiva.com subdomains each
 * resolve to a company server-side, and that is the answer for every real
 * visitor.
 *
 * It deliberately does NOT read `selectedCompanyId`. That key belongs to the
 * admin application, and sending it from the public pages meant any staff
 * member browsing xpiva.com was served whichever company they happened to have
 * selected — one tenant's website appearing on another tenant's domain.
 *
 * Previewing another company's site from the admin is an explicit act instead:
 * ?preview_company=<uuid> on the URL starts a preview for that browser tab
 * only, and it stays for in-site navigation so the links keep working.
 */
const KEY = 'cmsPreviewCompanyId';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function publicTenantHeaders() {
  try {
    const asked = new URLSearchParams(window.location.search).get('preview_company');
    if (asked && UUID.test(asked)) {
      sessionStorage.setItem(KEY, asked);
      return { 'X-Company-Id': asked };
    }
    const held = sessionStorage.getItem(KEY);
    return held && UUID.test(held) ? { 'X-Company-Id': held } : {};
  } catch {
    return {};
  }
}

/** True when this tab is previewing a company other than the host's own. */
export function isPreviewing() {
  try { return !!sessionStorage.getItem(KEY); } catch { return false; }
}
